var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"full-screen"}},[_c('div',{attrs:{"id":"append"}}),_c('div',{staticClass:"full-screen_click",class:{__opened: _vm.opened},attrs:{"id":"full-screen_click"},on:{"click":_vm.openFull}})])
}
var staticRenderFns = []

export { render, staticRenderFns }